<script>
import ClickOut from '../../../utils/directives/clickout'
import AclCheckMixins from './mixins/AclCheckMixins'

export default {
  name: 'BtnOptions',
  directives: {ClickOut},
  mixins: [AclCheckMixins],
  props: {
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    title: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      open: false,
      show: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.show = !!this.$el.getElementsByTagName('li').length
    })
  },
  methods: {
    toggle () {
      this.open = !this.open
    },
    hide () {
      this.open = false
    }
  }
}
</script>

<template>
  <div class="btn-group dropdown" :class="{open: open}"  v-click-out="hide" v-show="show">
    <button class="btn btn-sm btn-dark" data-toggle="dropdown" tabindex="1" aria-expanded="false" @click.stop.prevent="toggle">
      <i class="fa fa-lock m-r-xs"></i> {{ title }} <span class="caret"></span>
    </button>
    <ul class="dropdown-menu no-padder">
      <li v-if="ACL.check(option.acl, currentUser.id)" v-for="(option, index) in options" :key="index">
        <a @click="$emit(option.emit)">
          <i :class="`fa fa-${option.icon || 'lock'} m-r-xs`"></i> {{option.label}}
        </a>
      </li>
    </ul>
  </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// BtnOptions.vue?548c636f